<template>
  <div class="about-main">
    <div class="about-ab bgA01"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-title">
        <h2>What is
          <span>WEIMAJIE</span>？</h2>
        <h3>关于威马捷</h3>
        <div class="page-scroll">
          <img :src="scroll"
               alt="">
        </div>
      </div>
    </div>
    <div class="about-ab bgA02"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title01">About Us</h2>
        <h3 class="content-subtitle">威马捷公司介绍</h3>
        <div class="content-text">
          <div class="content-para">
            <p>北京威马捷致力为有需要的客户提供全球医疗援助服务，
              <br/> 以「广阔世界，伴您同行」为宗旨，提供全球医疗救援及出国就医援助，医疗大健康等服务。
              <br/> 我们在事故发生时提供当地就医安排及妥善的远程救援服务
              <br/> 凭借强大的网络资源数据库及医疗转运救援地图系统为您提供的医疗转运服务。
              <br/> 愿我们的服务，无论何时何地，让您在文化迥然的异国他乡，享受安心，安全的医疗健康服务。
            </p>
          </div>
          <div class="content-para">
            <p>「医疗援助」是一项被社会尊敬的事业，
              <br/> 我们的每一位员工也都为自己的工作而感到骄傲自豪。
              <br/> 我们以「帮助他人」的理念对公司员工进行专业培训，
              <br/> 通过客户的真实反馈不断提高自己的服务品质。
            </p>
          </div>
          <div class="content-para">
            <p>北京威马捷凭借资深的医疗救援经验知识【Skill ＆ Know-how】，
              <br/> 遍布全球的医疗网络资源及数据处理系统【Digital ＆ Data】，
              <br/> 以日式的服务标准和对待家人一样的细心体贴【Communication ＆ Heart】，
              <br/> 真诚地为每一位客人提供专属的医疗健康【Medical ＆ Health】援助服务。
            </p>
          </div>
          <div class="content-para">
            <p>我们立志将威马捷发展为全球服务最好的医疗救援公司，并为此不断努力。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="about-ab bgA03"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title02">Four Advantage</h2>
        <h3 class="content-subtitle">4大优势资源</h3>
        <Carousel style="width: 686px;margin: 0 auto"
                  v-model="carouselIndex"
                  :autoplay="carouselSetting.autoplay"
                  :autoplay-speed="carouselSetting.autoplaySpeed"
                  :dots="carouselSetting.dots"
                  :radius-dot="carouselSetting.radiusDot"
                  :trigger="carouselSetting.trigger"
                  :arrow="carouselSetting.arrow">
          <CarouselItem>
            <div class="demo-carousel">
              <img :src="carouselImg1"
                   alt="">
              <h4 class="carouselTitle">【专业的救援客服中心】</h4>
              <div class="carouselContent">
                <p>24H×365天服务的救援呼叫中心。</p>
                <p>10年以上医疗援助经验的客服人员。</p>
                <p>中，英，日，韩等多国语言对应。</p>
                <p>专业的呼叫中心电话系统及案件管理系统。</p>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="demo-carousel">
              <img :src="carouselImg2"
                   alt="">
              <h4 class="carouselTitle">【广泛的全球合作网络】</h4>
              <div class="carouselContent">
                <p>威马捷在中国设有北京总公司，上海，大连，广州分公司</p>
                <p>共4个据点，同时联合集团公司EAJ的全球救援网络</p>
                <p>（日本东京/冲绳，泰国曼谷，新加坡，美国里士满，</p>
                <p>英国伦敦，法国巴黎，加拿大温哥华），</p>
                <p>通过全球20,000家以上的合作医院和约3,000家供应商网络，</p>
                <p>为每一位客户的安心之旅保驾护航。</p>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="demo-carousel">
              <img :src="carouselImg3"
                   alt="">
              <h4 class="carouselTitle">【丰富的医疗转运经验】</h4>
              <div class="carouselContent">
                <p>通过近20年，近3000件国际医疗转运案件的经验积累，</p>
                <p>专业解析转运路线做成自有的救援地图服务系统AMS，</p>
                <p>迅速并专业地为重伤患者提供就医及转运方案。</p>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="demo-carousel">
              <img :src="carouselImg4"
                   alt="">
              <h4 class="carouselTitle">【个性化定制救援服务】</h4>
              <div class="carouselContent">
                <p>根据客户需求，对指定的地区展开前期调查和专业评估，</p>
                <p>并量身定做符合当地的健康管理、医疗及重伤转运方案。</p>
                <p>派遣医疗人员进驻企业驻地，通过指导，培训，管理等</p>
                <p>全面的健康医疗管理咨询服务，及专业的紧急救援能力，</p>
                <p>为客户在当地的展开业务提供安心的医疗援助保障。</p>
              </div>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
    </div>
    <div class="about-ab bgA04"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title02" style="color: #444;">Results & Structure</h2>
        <h3 class="content-subtitle">业绩&体制</h3>
        <div class="page-introduce">
          <div class="introduce-cell"
               style="width: 772px;">
            <p>年提供医疗救援服务案件<span style="color: #cf1300;">>67,000件</span></p>
          </div>
          <div class="introduce-cell">
            <p>年呼入电话数</p>
            <p style="color: #cf1300;">>200,000通</p>
          </div>
          <div class="introduce-cell">
            <p>年处理医疗理赔单据</p>
            <p style="color: #cf1300;">>103,000件</p>
          </div>
          <div class="introduce-cell">
            <p>年提供医疗转运案件</p>
            <p style="color: #cf1300;">>200件</p>
          </div>
          <div class="introduce-cell">
            <p>年累计垫付医疗费</p>
            <p style="color: #cf1300;">>350,00万CNY</p>
          </div>
        </div>
      </div>
    </div>
    <div class="about-ab bgA05"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title02">Comfortable Environment</h2>
        <h3 class="content-subtitle">环境氛围</h3>
        <div class="page-introduce">
          <div class="introduce-cell"
               style="width: 772px;">
            <p>公司员工年龄主要在25岁到45岁之间，其中女性员工占比70%。</p>
            <p>公司有完善的福利制度，尤其对于女性员工孕产期间给予关怀。</p>

          </div>
          <div class="introduce-cell"
               style="width: 772px;">
            <p>开放式的工作空间让各个部门之间可以很好地进行沟通及相互协作。</p>
            <p>舒适明快的工作环境让员工保持身心愉快。</p>

          </div>
          <div class="introduce-cell"
               style="width: 772px;">
            <p>每年通过个人目标管理及考核来帮助员工不断成长。</p>
            <p>目前公司55%的管理人员为女性。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="under-link">
      <ol class="under-link-wrap">
        <li>
          <router-link class="active"
                       to="/about">
            <span>关于威马捷</span>
          </router-link>
        </li>
        <li>
          <router-link to="/activities">
            <span>威马捷服务</span>
            <i class="link-arrow"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/assistances">
            <span>医疗救援的必要性</span>
            <i class="link-arrow"></i>
          </router-link>
        </li>
      </ol>
    </div>
    <!-- <div class="page-serve">
        <h4>我们服务的集团客户</h4>
        <div class="serve-customer">
          <div>
            <img :src="global" alt="">
            <p>国际医疗保险</p>
          </div>
          <div>
            <img :src="global" alt="">
            <p>国际医疗保险</p>
          </div>
          <div>
            <img :src="global" alt="">
            <p>国际医疗保险</p>
          </div>
        </div>
      </div>  -->
  </div>
</template>
<script>
import scroll from '@/assets/images/about/about_scroll.png';
import carouselImg1 from '@/assets/images/about/about_top_slide_num01.png'
import carouselImg2 from '@/assets/images/about/about_top_slide_num02.png'
import carouselImg3 from '@/assets/images/about/about_top_slide_num03.png'
import carouselImg4 from '@/assets/images/about/about_top_slide_num04.png'
import global from '@/assets/images/home/icon-link1.png'
export default {
  data () {
    return {
      scroll,
      carouselImg1,
      carouselImg2,
      carouselImg3,
      carouselImg4,
      global,
      carouselIndex: 0,
      carouselSetting: {
        autoplay: false,
        autoplaySpeed: 2000,
        dots: 'outside',
        radiusDot: true,
        trigger: 'click',
        arrow: 'always'
      },
      clientHeight: ''
    }
  },
  mounted () {
    var h = document.documentElement.clientHeight || document.body.clientHeight;

    this.clientHeight = h;
    // console.log(this.clientHeight)
  }
}
</script>
<style lang="less" scoped>
.about-main {
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 0;
  clear: both;
  zoom: 1;
  position: relative;
  z-index: 0;
}
.about-ab {
  width: 100%;
  padding: 60px 0;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bgA01 {
  background-image: url('../assets/images/about/about_top_bg01.jpg');
  background-position: center top;
}
.bgA02 {
  background-image: url('../assets/images/about/about_top_bg02.jpg');
  background-position: center top;
}
.bgA03 {
  background-color: #61afd7;
  background-image: url('../assets/images/about/about_top_bg03.png');
  background-position: center 88%;
  background-size: 80%;
}
.bgA04 {
  background-image: url('../assets/images/about/about_top_bg04.png');
  background-position: center top;
}
.bgA05 {
  background-image: url('../assets/images/about/about_top_bg12.png');
  background-position: center top;
}
.page-title:before {
  position: absolute;
  left: 0;
  top: 0;
  content: '';
  display: block;
  width: 10px;
  height: 60px;
  background: none;
}
.page-title {
  background: none!important;
  h2 {
    font-size: 60px;
    color: #fff;
    line-height: 70px;
    text-align: center;
    margin-bottom: 28px;
    span {
      color: #cf1300;
    }
  }
  h3 {
    width: 204px;
    height: 58px;
    /*background: rgba(0, 0, 0, 0.3);*/
    /*border: 2px solid #fff;*/
    color: #fff;
    font-size: 28px;
    line-height: 28px;
    text-align: center;
    line-height: 58px;
    margin: 0 auto 34px;
  }
  .page-scroll {
    width: 80px;
    height: 80px;
    margin: 0 auto;
  }
}
.page-content {
  .content-title01 {
    font-size: 60px;
    color: #444;
    line-height: 80px;
    text-align: center;
  }
  .content-title02 {
    font-size: 60px;
    color: #fff;
    line-height: 80px;
    text-align: center;
  }
  .content-subtitle {
    width: 200px;
    height: 40px;
    background: #ab291b;
    font-size: 24px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    padding: 0 14px;
    margin: 0 auto 36px;
  }
  .content-text {
    width: 686px;
    background: #fcfcfc;
    padding: 40px 0 24px;
    margin: 0 auto;
    .content-para {
      margin-bottom: 26px;
    }
    p {
      font-size: 14px;
      color: #444;
      line-height: 26px;
      text-align: center;
    }
  }
}

.demo-carousel {
  position: relative;
  width: 686px;
  height: 354px;
  background: #ddedf5;
  padding: 50px;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 168px;
    height: 157px;
  }
  .carouselTitle {
    font-size: 20px;
    color: #0f6aa1;
    line-height: 36px;
    text-align: center;
    margin: 0 auto 20px;
  }
  .carouselContent {
    p {
      color: #444;
      font-size: 16px;
      line-height: 26px;
      text-align: center;
    }
  }
}
.page-introduce {
  display: flex;
  width: 838px;
  height: 528px;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: rgba(255, 255, 255, 0.8);
  flex-wrap: wrap;
  .introduce-cell {
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 350px;
    height: 122px;
    p {
      font-size: 22px;
      color: #444;
      line-height: 28px;
      text-align: center;
    }
  }
}
.under-link {
  background: #fff;
  padding: 50px 0;
  .under-link-wrap {
    width: 700px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 auto;
    li {
      width: 160px;
      height: 160px;
      margin: 0 auto;
      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: solid 2px #aa2619;
        color: #aa2619;
        border-radius: 50%;
        span {
          display: block;
          display: block;
          margin-top: 40px;
          font-size: 16px;
        }
        .link-arrow {
          display: block;
          width: 20px;
          height: 20px;
          margin-top: 20px;
          background: url('../assets/images/about/arrow-circle-up.png')
          no-repeat center;
          background-size: 100% auto;
        }
      }
      a.active {
        color: #fff;
        background-color: #aa2619;
        span {
          margin-top: 2px;
        }
      }
    }
  }
}
.page-serve {
  padding: 50px 0;
  h4 {
    font-size: 26px;
    color: #333130;
    line-height: 30px;
    text-align: center;
    margin-bottom: 34px;
  }
  .serve-customer {
    width: 1000px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin: 0 auto;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 300px;
      height: 110px;
      background: #fff;
      border: 1px solid #d6d6d6;
      padding: 20px;
      img {
        width: 60px;
        height: 60px;
        margin-right: 16px;
      }
      p {
        font-size: 30px;
        color: #ae1e10;
        line-height: 60px;
      }
    }
  }
}
</style>
<style lang="less">
.ivu-carousel {
  .ivu-carousel-arrow {
    width: 80px;
    height: 80px;
    font-size: 4em;
  }
  .ivu-carousel-arrow.left {
    left: -20%;
  }
  .ivu-carousel-arrow.right {
    right: -20%;
  }
}
.ivu-carousel-dots li {
  width: 30px;
  height: 30px;
  button {
    opacity: 1;
  }
  button.radius {
    width: 30px;
    height: 30px;
    background: #fff;
  }
}
.ivu-carousel-dots li.ivu-carousel-active > button.radius {
  width: 30px;
  height: 30px;
  background: #a3362d;
}
</style>
